module.exports = __webpack_public_path__ + "img/TobiasBornmann_140x140_rund.4479f2da.jpg";